// extracted by mini-css-extract-plugin
module.exports = {"languageBlock":"style_languageBlock__HmZk7","languageBlock__item":"style_languageBlock__item__dII7s","languageElement":"style_languageElement__Ic3nY"};